import fetchUtils from "utils/fetchUtils";

const postUpload = async (body: object) => {
	try {
		const resp = await fetchUtils.postCustom(`/b2b/upload_csd`, body);
		return resp;
	} catch (error) {
		throw error;
	}
}

export { postUpload };